import { render } from "./inputRange.vue?vue&type=template&id=2057e7c4&ts=true"
import script from "./inputRange.vue?vue&type=script&lang=ts"
export * from "./inputRange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__